import React, { useState, useEffect } from 'react'

import Select from '../../select'

const { Option } = Select

export default (props) => {
  const {
    options,
    params,
    queryKey = 'name',
    fieldNames = {
      label: 'label',
      value: 'value',
    },
    loadData,
    ...rest
  } = props
  const [items, setItems] = useState(options || [])
  const [query, setQuery] = useState('')
  const onSearch = (val) => {
    setQuery(val)
  }

  if (loadData) {
    useEffect(() => {
      loadData({
        [queryKey]: query,
        ...(params || {}),
      }).then((items) => {
        setItems(items)
      })
    }, [params, query])
  }

  useEffect(() => {
    setItems(options || [])
  }, [options])

  return (
    <Select allowClear showSearch optionFilterProp="children" onSearch={onSearch} {...rest}>
      {items.map((item) => {
        const labelKey = fieldNames?.label || 'label'
        const valueKey = fieldNames?.value || 'value'
        const value = item instanceof Object ? item[valueKey] : item
        const label = item instanceof Object ? item[labelKey] : item
        const optionProps = item instanceof Object ? item : {}

        return (
          <Option {...optionProps} key={value} value={value}>
            {label}
          </Option>
        )
      })}
    </Select>
  )
}
